import Breadcrumbs from '@atlaskit/breadcrumbs/breadcrumbs';
import { BreadcrumbsItem } from '@atlaskit/breadcrumbs/breadcrumbs-item';
import { BreadcrumbsSkeleton } from '@atlaskit/breadcrumbs/breadcrumbs-skeleton';
import { BreadcrumbsSkeletonItem } from '@atlaskit/breadcrumbs/breadcrumbs-skeleton-item';

export type FastshiftPageBreadcrumbItem = {
	href?: string;
	text: string;
};

type FastshiftPageBreadcrumbsProps = {
	isLoading: boolean;
	items: FastshiftPageBreadcrumbItem[];
	loadingLabel: string;
	skeletonWidths: number[];
	testId: string;
};

export const FastshiftPageBreadcrumbs = ({
	isLoading,
	items,
	loadingLabel,
	skeletonWidths,
	testId,
}: FastshiftPageBreadcrumbsProps) => {
	if (isLoading) {
		return (
			<BreadcrumbsSkeleton label={loadingLabel} testId={testId}>
				{skeletonWidths.map((width, index) => (
					<BreadcrumbsSkeletonItem key={`${width}-${index}`} width={width} />
				))}
			</BreadcrumbsSkeleton>
		);
	}

	return (
		<Breadcrumbs>
			{items.map(({ href, text }) => (
				<BreadcrumbsItem key={`${href}-${text}`} href={href} text={text} />
			))}
		</Breadcrumbs>
	);
};
